import { StateManager } from './StateManager';

export interface FanHealth {
  mainPercent: number;
  controlPercent: number;
  mainColor: string;
  controlColor: string;
}

export interface CapacitorHealth {
  status: string;
  color: string;
}

export class PredictiveHealth {
  private readonly FAN_MAIN_MAX = 50000;
  private readonly FAN_CTRL_MAX = 30000;

  constructor(private state: StateManager) {}

  getFanHealth(): FanHealth {
    const mainHours = this.state.get('fanMainHours');
    const ctrlHours = this.state.get('fanControlHours');

    const mainPct = Math.min(100, (mainHours / this.FAN_MAIN_MAX) * 100);
    const ctrlPct = Math.min(100, (ctrlHours / this.FAN_CTRL_MAX) * 100);

    return {
      mainPercent: Math.round(mainPct * 10) / 10,
      controlPercent: Math.round(ctrlPct * 10) / 10,
      mainColor: mainPct > 80 ? '#ffb700' : '#00ff9d',
      controlColor: ctrlPct > 80 ? '#ffb700' : '#00ff9d',
    };
  }

  getCapacitorHealth(): CapacitorHealth {
    const daysOffline = this.state.get('daysOffline');

    if (daysOffline > 365) {
      return {
        status: 'Reforming Crítico (Risco de Explosão)',
        color: '#ff4757',
      };
    }
    if (daysOffline > 180) {
      return {
        status: 'Ramp Up de Tensão Recomendado',
        color: '#ffb700',
      };
    }
    return {
      status: 'Carga Direta Permitida',
      color: '#00ff9d',
    };
  }
}
